<style scoped>
.footer-link {
    @apply block text-sm w-full text-center py-2;
}
.footer-link:hover {
    @apply text-red;
}
.footer-link:focus {
    @apply outline-none text-darkGrayishBlue;
}
@screen sm {
    .footer-link {
        @apply pt-0 mb-1 text-left w-auto;
    }
}
</style>

<template>
    <div class="py-4 bg-primary">
        <div
            class="max-w-site mx-auto flex flex-wrap justify-center text-white"
        >
            <div v-if="user" class="w-1/3 sm:w-1/5 flex flex-col items-center">
                <div class="mb-2 pb-2 border-b-2 border-white">
                    {{ $t('site.account') }}
                </div>
                <router-link
                    tag="button"
                    to="/account/accountInfo"
                    class="footer-link"
                >
                    {{ $t('account.info') }}
                </router-link>
                <router-link
                    tag="button"
                    to="/account/orderHistory"
                    class="footer-link"
                >
                    {{ $t('order.history') }}
                </router-link>
            </div>
            <div
                v-if="user && !isFriendCustomer"
                class="w-1/3 sm:w-1/5 flex flex-col items-center"
            >
                <div class="mb-2 pb-2 border-b-2 border-white">
                    {{ $t('credit.point.name') }}
                </div>
                <router-link
                    tag="button"
                    to="/account/creditPointHistory"
                    class="footer-link"
                >
                    {{ $t('credit.point.history') }}
                </router-link>
                <!--
                <router-link
                    tag="button"
                    :to="{ name: 'tcoin' }"
                    class="footer-link"
                >
                    {{ 'T-Coins 獎賞詳情' }}
                </router-link>
                -->
                <router-link
                    tag="button"
                    to="/account/feedback"
                    class="footer-link"
                >
                    {{ '產品體驗回饋' }}
                </router-link>
            </div>
            <div class="w-1/2 sm:w-1/5 flex flex-col items-center">
                <div class="mb-2 pb-2 border-b-2 border-white">
                    {{ $t('site.about.tryhala') }}
                </div>
                <router-link tag="button" to="/contactUs" class="footer-link">
                    {{ $t('site.contact.us') }}
                </router-link>
                <router-link
                    tag="button"
                    to="/privacyPolicy"
                    class="footer-link"
                >
                    {{ $t('site.privacy.policy') }}
                </router-link>
                <router-link tag="button" to="/termsOfUse" class="footer-link">
                    {{ $t('site.terms.of.use') }}
                </router-link>
                <router-link
                    tag="button"
                    :to="{ name: 'faq' }"
                    class="footer-link"
                >
                    {{ $t('site.FAQ') }}
                </router-link>
            </div>
            <div class="w-1/3 sm:w-1/5 flex flex-col items-center">
                <tr>
                    <td>
                        <div class="pb-2">
                            {{ $t('site.follow.us') }}
                        </div>
                        <div class="flex flex-wrap">
                            <a
                                href="https://www.facebook.com/TryHaLa/"
                                target="_blank"
                            >
                                <div class="icon icon-scale w-8 h-8 text-white">
                                    <facebookSvg />
                                </div>
                            </a>
                            <a
                                href="https://www.linkedin.com/showcase/tryhala/"
                                target="_blank"
                            >
                                <div
                                    class="icon icon-scale w-8 h-8 p-1 text-white"
                                >
                                    <linkedinSvg class="" />
                                </div>
                            </a>
                        </div>
                    </td>
                    <td>
                        <div
                            class="mt-4 ml-4 flex flex-col justify-center items-center"
                        >
                            <div class="text-xs">{{ $t('site.partner') }}</div>
                            <a href="https://melson.tech/" target="_blank">
                                <img
                                    :src="melsonImg"
                                    class="w-12 mb-1"
                                    alt=""
                                />
                            </a>
                        </div>
                    </td>
                </tr>
                <div class="mt-4 flex flex-col justify-center items-center">
                    <a href="http://onelink.to/tryhala" target="_blank">
                        <img :src="mobileAppImg" class="w-32" alt="" />
                    </a>
                </div>
            </div>

            <div
                v-if="paymentMethods.length"
                class="w-2/3 sm:w-1/5 flex flex-col items-start lg:items-center"
            >
                <div class="pb-2">
                    {{ $t('site.payment.method') }}
                </div>
                <div class="flex flex-wrap items-center w-full">
                    <img
                        v-for="(p, pi) in paymentMethods"
                        :key="pi"
                        class="w-12 px-1 lg:w-1/3 lg:px-4"
                        :src="paymentImg(p)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import melsonImg from '@/assets/img/melson2_white_with_company_name.png';
import facebookSvg from '../assets/svg/facebook.svg';
import linkedinSvg from '../assets/svg/linkedin.svg';
import mobileAppImg from '@/assets/img/mobile_app_download.png';
import { paymentInfos } from './paymentMethodInfo.js';

export default {
    components: { facebookSvg, linkedinSvg },
    created() {
        this.melsonImg = melsonImg;
        this.mobileAppImg = mobileAppImg;
    },
    methods: {
        paymentImg(paymentOption) {
            return paymentInfos.find(
                pi =>
                    pi.pymtSrvcPrvdId === paymentOption.pymtSrvcPrvdId &&
                    pi.pymtMthdId === paymentOption.pymtMthdId
            ).img;
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        paymentMethods() {
            if (
                this.$store.state.companyPaymentMethodList &&
                this.$store.state.companyPaymentMethodList.length
            ) {
                return this.$store.state.companyPaymentMethodList;
            }

            return [];
        },
        isFriendCustomer() {
            return this.$store.getters.isFriendCustomer;
        }
    }
};
</script>
